import React, { useRef, useState } from "react";
import { Play } from "lucide-react";
import { brandStory } from "../mock";

const NAVY = "#1B1F5C";

const BrandStory = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
      setPlaying(true);
    }
  };

  return (
    <section className="py-14 md:py-20 bg-white relative overflow-hidden">
      {/* doodle stars right */}
      <svg className="absolute top-10 right-6 w-5 h-5 text-[#35C3C1]" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>
      <svg className="absolute top-24 right-12 w-7 h-7 text-[#F79433]" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>

      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-16 items-center">
          {/* Left text */}
          <div className="text-left">
            <p className="text-[12px] font-extrabold tracking-[0.18em] text-[#35C3C1] uppercase">Our Brand Story</p>
            <h2 className="mt-3 font-display font-extrabold text-3xl md:text-4xl leading-tight" style={{ color: NAVY }}>
              Bringing Joy, Learning<br className="hidden md:block" /> & Imagination to Every Child
            </h2>
            <p className="mt-4 text-[14.5px] font-medium text-[#5A5A75] leading-relaxed max-w-sm">
              Adhira & Appa Toys was born out of love – a father and daughter's dream to create a world filled with happiness, creativity and endless possibilities for every child.
            </p>
            <button
              onClick={handlePlay}
              className="mt-7 inline-flex items-center gap-3 pl-6 pr-2 h-12 rounded-full text-white text-[12px] font-extrabold tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-transform duration-200"
              style={{ backgroundColor: NAVY }}
            >
              WATCH OUR STORY
              <span className="h-8 w-8 rounded-full bg-white flex items-center justify-center">
                <Play size={14} className="ml-0.5" style={{ color: NAVY, fill: NAVY }} />
              </span>
            </button>
          </div>

          {/* Right video */}
          <div className="relative rounded-3xl overflow-hidden shadow-xl group">
            <video
              ref={videoRef}
              controls={playing}
              preload="metadata"
              playsInline
              className="w-full aspect-video object-cover bg-[#1B1F5C]"
              onPause={() => setPlaying(false)}
              onPlay={() => setPlaying(true)}
            >
              <source src="/videos/brand-story.mp4" type="video/mp4" />
              <source src="/videos/brand-story.webm" type="video/webm" />
            </video>
            {!playing && (
              <button onClick={handlePlay} className="absolute inset-0 flex flex-col items-center justify-center" aria-label="Play brand story video">
                <span className="h-16 w-16 md:h-20 md:w-20 rounded-full bg-white/95 shadow-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                  <Play size={28} className="ml-1" style={{ color: NAVY, fill: NAVY }} />
                </span>
                <span className="absolute bottom-10 md:bottom-12 text-white font-display font-bold text-base md:text-xl drop-shadow-lg px-4 text-center">
                  {brandStory.caption}
                </span>
                <span className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/50 to-transparent pointer-events-none" />
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandStory;
